export type PagePosition = 'Top' | 'Left' | 'Right';
export const PagePosition = {
  Top: 'Top' as PagePosition,
  Left: 'Left' as PagePosition,
  Right: 'Right' as PagePosition,
};
